import React from 'react';
import styled from 'styled-components';
import {SIZES, Typography} from '@fupa/fupa-uikit';
import {FlexContainer, StyledTypography} from 'app/styles/content';
import {parseNumber} from 'app/helpers/helpers';
import {Group} from '@mui/icons-material';

const Container = styled(FlexContainer)`
  padding: 0 ${SIZES['16']} ${SIZES['8']} ${SIZES['24']};
  justify-content: space-between;
  align-items: center;
`;

const TileContainer = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
`;

const BigGroup = styled(Group)`
  font-size: ${SIZES['72']};
`;

const SpectatorsMainHeader = ({spectators, avgSpecs}) => {
  const totalSpectators = parseNumber(spectators);
  const avgSpectators = parseNumber(avgSpecs);

  return (
    <Container>
      <BigGroup color='secondary' />
      <TileContainer>
        <StyledTypography variant='headline2' lineHeight={36} textAlign='center'>
          {totalSpectators}
        </StyledTypography>
        <Typography variant='caption1'>ges. Zuschauer</Typography>
      </TileContainer>
      <TileContainer>
        <StyledTypography variant='headline2' lineHeight={36} textAlign='center'>
          {avgSpectators}
        </StyledTypography>
        <Typography variant='caption1'>Zuschauer ∅</Typography>
      </TileContainer>
    </Container>
  );
};

export default SpectatorsMainHeader;
